// sunGenerator.js
var SunGenerator = pc.createScript('sunGenerator');


SunGenerator.attributes.add('standAlone', {type: 'boolean', title: 'standAlone'});
SunGenerator.attributes.add('baseSphere', {type: 'entity', title: 'baseSphere'});
SunGenerator.attributes.add('overlaySphere', {type: 'entity', title: 'overlaySphere'});
SunGenerator.attributes.add('innerCorona', {type: 'entity', title: 'innerCorona'});
SunGenerator.attributes.add('outerCorona', {type: 'entity', title: 'outerCorona'});
SunGenerator.attributes.add('sunRayCorona', {type: 'entity', title: 'sunRayCorona'});
SunGenerator.attributes.add('particlesAll', {type: 'entity', array: true, title: 'particlesAll'});
SunGenerator.attributes.add('sunRayTex', { type: 'asset', assetType: "texture", array: true});

SunGenerator.attributes.add('RHcolors', {type: 'curve', color: 'rgba', title: 'hrzSprngRssl'});
SunGenerator.attributes.add('sunSpotMaterials', {type: 'asset', array: true, title: 'sunspotMat'});

SunGenerator.attributes.add('dysonCaller', {type:'boolean', default:false});
SunGenerator.attributes.add('dysonGen', {type:'entity', default:null});

SunGenerator.attributes.add('divisor', {type:'number', default:1, title:'dysonSunCapper'});
SunGenerator.attributes.add('min', {type:'number', default:0, title:'minSunSize'});
SunGenerator.attributes.add('xrayBinary', {type:'boolean', default:false, title:'XrayBinary'});

// initialize code called once per entity
SunGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    //blackholetocall
    this.blackHoleScript = this.entity.parent.children[1].script.blackHoleGenerator;
    
    // randomValues
    this.colorRandom_set = 0;
    this.emitterRad = new Array(this.particlesAll.length);
    this.rndSpotMat = 0;
    this.randomRotation = 0;
    
    this.snBsMat = this.baseSphere.model.meshInstances[0].material;
    this.snOvMat = this.overlaySphere.model.meshInstances[0].material;
    this.inCrnMat = this.innerCorona.model.meshInstances[0].material;
    this.outCrnMat = this.outerCorona.model.meshInstances[0].material;
    //this.ubrCoronaMat = this.outerCorona.children[0].model.meshInstances[0].material;
    
    this.sunRay = this.sunRayCorona.model.meshInstances[0].material;
    this.baseColor = null;
    this.rndSize = 1;
    this.crnd = 0;
    this.rt = 0;
    this.rndRayText = null;
    this.r = 0; this.g = 0; this.b = 0;
    this.solarWind = 0;
    this.dysonSphere = true;
    this.oneTime = true;
    this.oneTimeDyson = true;
    this.testCounter = 0;
    
    this.url = new URL(window.top.location.href);
    this.urlseed = this.url.searchParams.get('s');
    this.urlDyson = false;
    if(this.urlseed !== null){
        this.urlDyson = true;
    }
    
    this.app.on('seeder:reset', this.trigger,this);
    this.trigger();
  
    
};

SunGenerator.prototype.trigger = function() {
        if(this.oneTime){
            this.setRandoms();
            this.setColor();
            this.setSun();
            this.oneTimeDyson = true;
        }
};

SunGenerator.prototype.setRandoms = function () {
    
    var mySeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom()+this.entity.name);
    
    
    this.solarWind = Math.floor(this.randomize()*12);
    
    // actual color of sun and particles value in int which get's picked from the curve 0.0-1.0
    this.crnd = this.randomize() * 9 + 1;
    // int to decimal float
    this.colorRandom_set = this.crnd / 10; 
    
    // aka particle lifetime - should be speed but works
    this.solarWind = Math.floor(this.randomize()*8) + 5; 
    
    // random size of the sun
    this.rndSize = Math.floor(this.randomize() * 10) + 5 / this.divisor; 
    
    // random radius of particle emitters
    for(l = 0; l < this.particlesAll.length; l++){
        this.emitterRad[l] = (0.25 + (this.randomize() * 0.75)) * this.rndSize;  
    }
    
    // random texture for sunspots
    this.rndSpotMat = Math.floor(this.randomize() * this.sunSpotMaterials.length); 
    
    // int value for sunrayTexture
    this.rt = Math.floor(this.randomize() * this.sunRayTex.length); 
    this.rayTexture = this.sunRayTex[this.rt];
    
    // random rotation of the corona texture -maybe not important- 
    this.randomRotation = this.randomize(); 
    
    //sunSeed - randomColor, solarWind, randomSize, sunSpotTexture, sunRayTextrue
    var starTemperature = Math.round(2000 / this.colorRandom_set);
    //console.log(seed);
    //console.log('temperature: ' + starTemperature + 'k');

};

SunGenerator.prototype.setColor = function() {

    //var HRgrd = this.RHcolors;
    this.r = this.RHcolors.get(0).value(this.colorRandom_set);
    this.g = this.RHcolors.get(1).value(this.colorRandom_set);
    this.b = this.RHcolors.get(2).value(this.colorRandom_set);

    this.baseColor = new pc.Color(this.r,this.g,this.b);    

    //believe it or not. the following loop changes the 2nd node in the color over time Graph of the particle systems
    //to a random color from Herzsprung-Russel-Diagramm for main row stars :P
    
    for(i = 0; i < this.particlesAll.length; i++){
        this.particlesAll[i].particlesystem.colorGraph.curves[0].keys[1][1] = this.r;
        this.particlesAll[i].particlesystem.colorGraph.curves[1].keys[1][1] = this.g;
        this.particlesAll[i].particlesystem.colorGraph.curves[2].keys[1][1] = this.b;
        this.particlesAll[i].setLocalScale(31.400932790302175*this.rndSize, 31.400932790302175*this.rndSize, 31.400932790302175*this.rndSize);
        this.particlesAll[i].particlesystem.emitterRadius = this.emitterRad[i];      
        this.particlesAll[i].particlesystem.rebuild();
        if(this.particlesAll[i].name != 'dustParticles'){
            this.particlesAll[i].particlesystem.lifetime = this.solarWind; 
        }
        this.particlesAll[i].particlesystem.rebuild();
    }

};

SunGenerator.prototype.setSun = function(){

    var bc = this.baseColor;
    var rz = this.rndSize;
    
    this.overlaySphere.model.meshInstances[0].material = this.sunSpotMaterials[this.rndSpotMat].resource;
    this.overlaySphere.script.ScrollingMap.material = this.sunSpotMaterials[this.rndSpotMat].resource;
   
    this.rndRayText = this.rayTexture;
    var rndRot = this.randomRotation * 360;
    this.sunRayCorona.script.rotator.enabled = false;
    this.sunRayCorona.setLocalEulerAngles(90,0,rndRot);
    this.sunRayCorona.script.rotator.enabled = true;
    this.sunRay.diffuseMap = this.rndRayText.resource;
    this.sunRay.emissiveMap = this.rndRayText.resource;
    this.sunRay.opacityMap = this.rndRayText.resource;
    
    this.sunRay.emissive = bc;
    
    // var bcOuter = new pc.Color(0,0,0,0);
    // var bcSum = bc.r + bc.g + bc.b;
    // console.log('bcSum: ' + bcSum);
    // if(bcSum > 2){
    //     console.log('bcSum: ' + bcSum);
    //     bcOuter = {r: bc.r - 0.3,g: bc.b - 0.3,b: bc.b - 0.3,a:0.35};
    //     console.log('bcOuter: ' + bcOuter.r + ', ' + bcOuter.g + ', ' + bcOuter.b);
    // }
    // this.ubrCoronaMat.emissive = bcOuter;
  
    this.outCrnMat.emissive = bc;
   

    this.inCrnMat.emissive = bc;
    
    this.entity.children[0].setLocalScale(rz * 46, rz * 46, rz * 46);    
    this.entity.children[1].setLocalScale(rz * 45.75, rz * 45.75, rz * 45.75);

    this.snBsMat.emissiveMapTiling.x = this.snBsMat.emissiveMapTiling.y = rz/2;
    this.snOvMat.emissiveMapTiling.x = this.snOvMat.emissiveMapTiling.y = rz/2;
    
    this.snBsMat.emissive = bc;
    this.snOvMat.emissive = bc;
    
    this.testCounter += 1;
    //console.log('tc: ' + this.testCounter);
    

    //this.baseSphere.model.meshInstances[1].material = this.snBsMat;
    
    this.snBsMat.update();
   // this.ubrCoronaMat.update();
    this.outCrnMat.update();
    this.sunRay.update();
    this.inCrnMat.update();
    this.snOvMat.update();
    //reset
    //.log('emissive: ' + this.outCrnMat.emissive.r + ', ' + this.outCrnMat.emissive.g + ', ' + this.outCrnMat.emissive.b);
       
    if(this.xrayBinary){
       this.blackHoleScript.initialize();
     //  this.blackHoleScript.generateBlackHole();
    }
    
    if(this.dysonCaller){
        if(this.oneTimeDyson){
            if(!this.urlDyson){
                this.dysonGen.script.dysonSphereGenerator.start(bc, rz);                
                this.oneTimeDyson = false;
            } else {
                
                var dist = this.entity.parent.parent.children[1];
                var dScript = dist.script.dysonDistributor;
                
                dScript.initialize();
                this.dysonGen.script.dysonSphereGenerator.start(bc, rz);   
                this.oneTimeDyson = false;
                this.urlDyson = false;
            }
        }
    }

    //this.once = true;
    //this.app.fire('sunGenerator:dysonTrigger', this.baseColor, this.rndSize);

};

// update code called every frame
SunGenerator.prototype.update = function(dt) {
//     if(this.standAlone){    
//         if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {

//         }
//     }
};

// swap method called for script hot-reloading
// inherit your script state here
// SunGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

